import ProjectCarousel from '../ProjectCarousel/ProjectCarousel';
import PublicationCarousel from '../PublicationCarousel/PublicationCarousel';
import Extensions from '../Extensions/Extensions';
import styles from './Portfolio.module.css'
import SeeAllButton from '../SeeAllButton/SeeAllButton';

function Portfolio() {
    return (
        <div className={styles.p}>
            <span> PORTFÓLIO </span>
            <div className={styles.container}>

                <div id={styles.pesquisa} className={styles.titulo}> PESQUISA </div>
                <SeeAllButton type={1} routertype={'/projetos'}/>
                
                <div className={styles.subtitulo + ' ' + styles.pesq}> Projetos </div>
    
                <ProjectCarousel />

                <div className={styles.subtitulo + ' ' + styles.pesq}> Publicações </div>
            
                <PublicationCarousel />
            
                <div className={styles.subtitulo + ' ' + styles.pesq}> TCCs </div>
            
                <PublicationCarousel />

            </div>

            <div className={styles.container}>
                <div id={styles.extensao} className={styles.titulo} > EXTENSÃO </div> 
                <SeeAllButton type={2} routertype={'/extensões'}/>
                
                <div className={styles.subtitulo + ' ' + styles.exten}> Cursos </div>

                <Extensions />

                <div className={styles.subtitulo + ' ' + styles.exten}> Prestação de Serviços </div>

                <Extensions />

                <div className={styles.subtitulo + ' ' + styles.exten}> Consultoria </div>

                <Extensions />

            </div>

        </div>
    )

}

export default Portfolio;